import React from "react";
import {
  noDataFound,
} from "../../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../../CommonMethhods/Constants";
import { numDifferentiation } from "../../../../CommonMethhods/CovertRupees";
import Loader from "../../../../Components/Common/Loader";

function PartnerHoldings(props) {
  //destructuring apply
  const {holdingData,loader,commonError,totalValue}=props
  const {
    Holdings,
    Stock_Symbol,
    Total_Qty,
    Avg_Cost_Price,
    LTP,
    Invested_Value,
    Current_Value,
    pnl_value,
    pnl_percent,
    clientId,
    Total,

  } = Constants;

  return (
      <div >
        <div className="holdings__title card-title d-flex justify-content-between">
      
        </div>
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : (
          <div className="holdings__table scroll-table">
            {holdingData && holdingData.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    {/* <th scope="col">{clientId}</th> */}
                    <th scope="col">{Stock_Symbol}</th>
                    <th scope="col">{Total_Qty}</th>
                    <th scope="col">{Avg_Cost_Price}</th>
                    <th scope="col">{LTP}</th>
                    <th scope="col">{Invested_Value}</th>
                    <th scope="col">{Current_Value}</th>
                    <th scope="col">Today's P&L</th>
                    <th scope="col">{pnl_value}</th>
                  </tr>
                </thead>

                <tbody>
                  {holdingData &&
                    holdingData.map((info, key) => {
                      const {
                        clientId,
                        sym,
                        qty,
                        avgPrice,
                        ltp,
                        invested,
                        value,
                        pnl,
                        todaysPnl,
                      } = info;
                      return (
                        <tr key={key}>
                          {/* <td>{clientId || "-"}</td> */}
                          <td>{sym || "-"}</td>
                          <td>{qty || 0}</td>
                          <td>{avgPrice || 0}</td>
                          <td>{ltp || 0}</td>
                          <td>{invested ? numDifferentiation(invested) : 0}</td>
                          <td>{value ? numDifferentiation(value) : 0}</td>
                          <td>
                            <span
                              className={
                               
                                todaysPnl == 0
                                  ? "text-muted"
                                  : todaysPnl < 0
                                  ? "red-txt"
                                  : "green-txt"
                              }
                            >
                              {numDifferentiation(todaysPnl) || 0}
                            </span>
                          </td>
                          <td>
                            <span
                              className={
                                pnl == 0
                                  ? "text-muted"
                                  : pnl < 0
                                  ? "red-txt"
                                  : "green-txt"
                              }
                            >
                              {pnl ? numDifferentiation(pnl) : 0.00}
                            </span>
                          </td>
                        
                        </tr>
                      );
                    })}
                </tbody>

                <tbody className="total-holdings">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col">{Total}</th>
                    <th scope="col">
                      {totalValue?.totalInvest
                        ? numDifferentiation(totalValue?.totalInvest)
                        : 0}
                    </th>

                    <th scope="col">
                      {totalValue?.totalCurrent
                        ? numDifferentiation(totalValue?.totalCurrent)
                        : 0}
                    </th>
                    <th
                      scope="col"
                      className={
                        totalValue?.todaysPnl === 0
                          ? "gray-text"
                          : totalValue?.todaysPnl > 0
                          ? "green-txt"
                          : "red-txt"
                      }
                    >
                      {totalValue?.todaysPnl
                        ? numDifferentiation(totalValue?.todaysPnl)
                        : 0}
                    </th>
                    <th
                      scope="col"
                      className={
                        totalValue?.pnl === 0
                          ? "gray-text"
                          : totalValue?.pnl > 0
                          ? "green-txt"
                          : "red-txt"
                      }
                    >
                      {console.log("todaysPnl",totalValue?.pnl)}
                      {totalValue?.pnl? numDifferentiation(totalValue?.pnl) : 0.00} 
                    </th>
                  </tr>
                </tbody>
              </table>
            ) : (
              commonError && (
                <h4 className="no-data">{noDataFound(commonError)}</h4>
              )
            )}
          </div>
        )}
      </div>
    // </div>
  );
}

export default PartnerHoldings;
